import { render } from "./RequireLabel.vue?vue&type=template&id=7b5a5c44"
import script from "./RequireLabel.vue?vue&type=script&lang=js"
export * from "./RequireLabel.vue?vue&type=script&lang=js"

import exportComponent from "/home/sites/fcs_dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/common/components/molecules/RequireLabel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7b5a5c44"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7b5a5c44', __exports__)) {
    console.log('reload')
    api.reload('7b5a5c44', __exports__)
  }
  
  module.hot.accept("./RequireLabel.vue?vue&type=template&id=7b5a5c44", () => {
    console.log('re-render')
    api.rerender('7b5a5c44', render)
  })

}


export default __exports__